import {
    GET_SHOW_REQUEST,
    GET_SHOW_SUCCESS,
    GET_SHOW_FAILURE,
    CLEAR_SHOW
} from '../actions/getShows';

const initialState = {
    show_loading: false,
    show_error: null,
    show_data: null,
};

export default function getShowsReducer(state = initialState, action) {
    switch (action.type) {
        case GET_SHOW_REQUEST:
            return { ...state, show_loading: true, show_error: null };
        case GET_SHOW_SUCCESS:
            return { ...state, show_loading: false, show_data: action.payload };
        case GET_SHOW_FAILURE:
            return { ...state, show_loading: false, show_error: action.payload };
        case CLEAR_SHOW:
            return { ...state, show_loading: false, show_data: null, show_error: null };
        default:
            return state;
    }
}

